import React, { useState, useEffect } from "react";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import { Link } from "react-scroll"; // Import Link from react-scroll
import logo from "./Logo.png";

import type { MenuProps } from "antd";
import { Button, Dropdown, Space } from "antd";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
   const [isInHome, setIsInHome] = useState(true);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const [menuOpen, setAboutUsMenuOpen] = useState(false);
  const openAboutUsMenu = () => {
    setAboutUsMenuOpen(true);
  };
  const closeAboutUsMenu = () => {
    setAboutUsMenuOpen(false);
  };

  // for scrolling
  // Function to scroll to an element with an offset
  const scrollToElementWithOffset = (elementId, offset) => {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth", // Smooth scroll
      });
    }
  };

  // drop down menu
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <a target="_blank" rel="noopener noreferrer" href="/MoreAboutUs">
          Know More About Us
        </a>
      ),
    },
  ];
  useEffect(() => {
    const handleScroll = () => {
      const homeSection = document.getElementById("home");
      const headerHeight = 100; // Adjust if header height is different
      const scrollPosition = window.scrollY + headerHeight;

      if (homeSection) {
        const sectionBottom = homeSection.offsetTop + homeSection.offsetHeight;

        setIsInHome(scrollPosition < sectionBottom);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Dynamic background class based on the section in view
  const headerBackgroundClass = isInHome
    ? "bg-white"
    : "bg-customBlueheader transition-colors duration-300 ease-in-out"; // Smooth color transition for 3 seconds

  return (
    <header
      className={`pt-8 sticky top-0 z-50 transition-colors duration-300 ${headerBackgroundClass}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <a href="#" className="text-2xl font-bold text-textColor">
              <img
                className="w-24 h-auto"
                src={logo}
                alt="Grand Shop Rwanda Logo"
              />
            </a>
          </div>

          {/* Social Media Icons */}
          <div
            className={`hidden md:flex space-x-4 ${
              isInHome ? "text-textColor" : "text-white"
            }`}
          >
            <a href="#" className=" hover:text-customBlue">
              <FaFacebookF size={20} />
            </a>
            <a href="#" className=" hover:text-customBlue">
              <FaTwitter size={20} />
            </a>
            <a href="#" className=" hover:text-customBlue">
              <FaInstagram size={20} />
            </a>
          </div>

          {/* Navigation Links with react-scroll */}
          <nav
            className={`hidden md:flex space-x-8 ${
              isInHome ? "text-textColor" : "text-white"
            }`}
          >
            <Link
              to="home"
              smooth={true}
              duration={500}
              className="cursor-pointer hover:text-customBlue"
            >
              Home
            </Link>
            <Link
              to="services"
              onClick={() => scrollToElementWithOffset("services", 800)}
              smooth={true}
              duration={500}
              className="cursor-pointer hover:text-customBlue"
            >
              Services
            </Link>
            <div>
              <Space direction="vertical">
                <Space wrap>
                  <Dropdown menu={{ items }} placement="bottom" arrow>
                    <Link
                      to="aboutus"
                      smooth={true}
                      duration={500}
                      className="cursor-pointer hover:text-customBlue"
                      onMouseEnter={openAboutUsMenu}
                      onMouseLeave={closeAboutUsMenu}
                    >
                      About Us
                    </Link>
                  </Dropdown>
                </Space>
              </Space>
            </div>

            <Link
              to="testimonials"
              smooth={true}
              duration={500}
              className="cursor-pointer hover:text-customBlue"
            >
              Testimonie
            </Link>
            <Link
              to="contactus"
              smooth={true}
              duration={500}
              className="cursor-pointer hover:text-customBlue"
            >
              Contact Us
            </Link>
          </nav>

          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-black focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="bg-customBlue md:hidden fixed inset-0 bg-bg py-0">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0">
              <a href="#home" className="text-2xl font-bold text-hovered">
                <img className="w-24 h-auto" src={logo} alt="Honex Logo" />
              </a>
            </div>

            {/* Navigation Links with react-scroll */}
            <nav className="hidden md:flex space-x-8">
              <Link
                to="home"
                smooth={true}
                duration={500}
                offset={-100}
                className="cursor-pointer hover:text-hovered"
                onClick={() => setIsOpen(false)} // Close menu on click
              >
                Home
              </Link>
              <Link
                to="aboutus"
                smooth={true}
                duration={500}
                offset={-100}
                className="cursor-pointer hover:text-hovered"
                onClick={() => setIsOpen(false)} // Close menu on click
              >
                About Us
              </Link>
              <Link
                to="mission"
                smooth={true}
                duration={500}
                offset={-100}
                className="cursor-pointer hover:text-hovered"
                onClick={() => setIsOpen(false)} // Close menu on click
              >
                Mission
              </Link>
              <Link
                to="vision"
                smooth={true}
                duration={500}
                offset={-1000}
                className="cursor-pointer hover:text-hovered"
                onClick={() => setIsOpen(false)} // Close menu on click
              >
                Vision
              </Link>
              <Link
                to="services"
                smooth={true}
                duration={500}
                offset={-100}
                className="cursor-pointer hover:text-hovered"
                onClick={() => setIsOpen(false)} // Close menu on click
              >
                Services
              </Link>
              <Link
                to="contact"
                smooth={true}
                duration={500}
                offset={-1000}
                className="cursor-pointer hover:text-hovered"
                onClick={() => setIsOpen(false)} // Close menu on click
              >
                Contact
              </Link>
            </nav>

            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-black focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>

          <nav className="flex flex-col justify-center items-center text-center gap-8 h-screen text-xl">
            <Link
              to="home"
              smooth={true}
              duration={500}
              offset={-70}
              className="block text-white cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link
              to="services"
              smooth={true}
              duration={500}
              offset={-70}
              className="block px-4 py-2 text-white hover:bg-bg cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              Services
            </Link>
            <Link
              to="aboutus"
              smooth={true}
              duration={500}
              offset={-70}
              className="block px-4 py-2 text-white hover:bg-bg cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              About Us
            </Link>
            <Link
              to="testimonials"
              smooth={true}
              duration={500}
              offset={-70}
              className="block px-4 py-2 text-white hover:bg-bg cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              Testimonials
            </Link>
            <Link
              to="contactus"
              smooth={true}
              duration={500}
              offset={-70}
              className="block px-4 py-2 text-white hover:bg-bg cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              Contact Us
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
